module.exports = __webpack_public_path__ + "img/img-a8c05907.3e3a4e84.png";